module.exports = __webpack_public_path__ + "media/high_school_students/member_login_btn-d938808e.png";